import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, message, Popconfirm } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import api from '../../services/api';

const TeamOrganizers = () => {
  const isMobile = window.innerWidth <= 768;
  const [organizers, setOrganizers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    loadOrganizers();
  }, []);

  const loadOrganizers = async () => {
    setLoading(true);
    try {
      const response = await api.get('/team-organizers');
      setOrganizers(response.data);
    } catch (error) {
      message.error('Erro ao carregar administradores');
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = async (values) => {
    try {
      await api.post('/team-organizers', values);
      message.success('Administrador criado com sucesso');
      setModalVisible(false);
      form.resetFields();
      loadOrganizers();
    } catch (error) {
      message.error(error.response?.data?.error || 'Erro ao criar administrador');
    }
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/team-organizers/${id}`);
      message.success('Administrador removido com sucesso');
      loadOrganizers();
    } catch (error) {
      message.error('Erro ao remover administrador');
    }
  };

  const columns = [
    {
      title: 'Nome',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: 'Adicionado em',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (date) => new Date(date).toLocaleDateString('pt-BR'),
    },
    {
      title: 'Ações',
      key: 'actions',
      render: (_, record) => (
        <Popconfirm
          title="Tem certeza que deseja remover?"
          onConfirm={() => handleDelete(record.id)}
          okText="Sim"
          cancelText="Não"
        >
          <Button type="link" danger icon={<DeleteOutlined />}>
            Remover
          </Button>
        </Popconfirm>
      ),
    },
  ];

  return (
    <div>
      <div
        style={{
          marginBottom: 16,
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent: 'space-between',
          alignItems: isMobile ? 'stretch' : 'center',
          gap: isMobile ? 12 : 0
        }}
      >
        <h2 style={{ margin: 0, lineHeight: 1.15, fontSize: isMobile ? 24 : 30 }}>Administradores do Time</h2>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setModalVisible(true)}
          style={isMobile ? { width: '100%' } : undefined}
        >
          Adicionar Administrador
        </Button>
      </div>

      <Table
        columns={columns}
        dataSource={organizers}
        loading={loading}
        rowKey="id"
        size={isMobile ? 'small' : 'middle'}
        scroll={{ x: 520 }}
      />

      <Modal
        title="Adicionar Administrador"
        open={modalVisible}
        onCancel={() => {
          setModalVisible(false);
          form.resetFields();
        }}
        footer={null}
        width={isMobile ? '100vw' : 500}
        style={isMobile ? { maxWidth: '100vw' } : undefined}
      >
        <Form form={form} onFinish={handleAdd} layout="vertical">
          <Form.Item
            name="username"
            label="Número de WhatsApp (DDD + Número)"
            rules={[
              { required: true, message: 'Digite o número de WhatsApp' },
              { pattern: /^[0-9]{10,11}$/, message: 'Digite apenas números (DDD + número, sem +55)' }
            ]}
          >
            <Input placeholder="Ex: 11999999999" maxLength={11} />
          </Form.Item>

          <Form.Item
            name="password"
            label="Senha"
            rules={[{ required: true, message: 'Digite a senha' }]}
          >
            <Input.Password placeholder="Digite a senha" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              Criar Administrador
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default TeamOrganizers;
